module.exports = __webpack_public_path__ + "static/media/kwanuko_dragon.1ed15cb6.png";